import qs from 'qs';

const ua = navigator.userAgent.toLowerCase();

/**
 * 操作系统信息
 */
export const browser = {
    isWeibo: () => ua.indexOf('weibo') > -1,
    isBaiduMap: () => ua.indexOf('baidumap_') > -1,
    isWechat: () => ua.indexOf('micromessenger') > -1,
    isIos: () => !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/),
    isAndroid: () => ua.indexOf('android') > -1 || ua.indexOf('adr') > -1
};

/**
 * 获取安卓系统版本号
 * @return {string} 安卓系统版本号 目前返回第一位
 */
export const getAndroidVersion = () => {
    let version = null;
    if (ua.indexOf('android') > 0) {
        const reg = /android [\d._]+/gi;
        const vInfo = ua.match(reg);
        version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号4.2.2
        version = parseInt(version.split('.')[0], 10); // 得到版本号第一位
    }

    return version;
};

/**
 * 获取iOS系统版本号
 * @return {string} ios系统版本号 目前返回第一位
 */
export const getIosVersion = () => {
    let version = null;
    if (ua.indexOf('like mac os x') > 0) {
        const reg = /os [\d._]+/gi;
        const vInfo = ua.match(reg);
        version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号9.3.2或者9.0
        version = parseInt(version.split('.')[0], 10); // 得到版本号第一位
    }

    return version;
};

/**
 * 获取字符串的哈希值
 * @param {string} str 原始字符串
 * @param {boolean} caseSensitive 是否区分大小写
 * @return {number} hashCode hash串
 */
export const getHashCode = (str, caseSensitive) => {
    if (!caseSensitive) {
        str = str.toLowerCase();
    }
    // 1315423911=b'1001110011001111100011010100111'
    let hash = 1315423911;
    let i;
    let ch;
    for (i = str.length - 1; i >= 0; i--) {
        ch = str.charCodeAt(i);
        hash ^= (hash << 5) + ch + (hash >> 2);
    }

    return hash & 0x7fffffff;
};

/**
 * 获取URL参数
 */
export const getUrlParams = () => {
    return qs.parse(window.location.search.split('?')[1]);
};

String.prototype.trim = function() {
    return this.replace(/(^\s*)|(\s*$)/g, '');
};
